import templateUrl from './edit-user-profile.component.html';
import { ImageCropperModal } from '../../shared/image-cropper/image-cropper-modal.component';
import { ROSTER_SEPARATE_EDIT_PAGES } from "../roster-flags";

export const EditUserProfileComponent = {
    templateUrl,
    controller: UserProfileController,
    controllerAs: "vm",
    bindings: {
        employee: "<",
        userProfile: "<",
        identity: "<",
        roleAccess: "<",
        featureManager: "<featureManagerSync",
        showPasswordEditor: "<",
        save: "&onSaveProfileAndAccount",
        sendPasswordReset: "&onSendPasswordReset"
    }
};

function UserProfileController($q, $uibModal, $state, employeeService, stateProvinceService,
    utilityService, fileService) {
    'ngInject';
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    const DEPT_900 = "900 1099";

    vm.userProfile;
    vm.employeeProfile;
    vm.GenderOptions = [];
    vm.$onInit = $onInit;
    vm.$onChanges = $onChanges;
    vm.onSubmit = onSubmit;
    vm.onChangeGender = onChangeGender;
    vm.onChangeUserAccount = onChangeUserAccount;
    vm.onChangeUserProfile = onChangeUserProfile;
    vm.profileImage = {};
    vm.profileImageFiles;
    vm.handleProfileImageFileSelected = handleProfileImageFileSelected;
    vm.clearProfileImageUpload = clearProfileImageUpload;
    vm.originalEmailAddress;
    vm.roleAccess;
    vm.loggedInUserID;
    vm.features;
    const PROFILE_IMG_SIZE_LIMIT_MB = 5;

    function $onInit() {
        vm.features = {};
        vm.features.separateEditPages = vm.featureManager.isEnabled(ROSTER_SEPARATE_EDIT_PAGES);
        vm.showExtension = true;
        vm.loggedInUserID = vm.identity.EmployeeID;
        utilityService.showLoading();
        window.onbeforeunload = onBeforeUnload;

        const loadStateProvinces = stateProvinceService.retrieveStateProvinces()
            .then(function (stateProvinces) {
                vm.stateProvinces = stateProvinces;
            });

        // Check if the user can go to the roster, and disable
        // links if they don't have access.
        vm.canAccessRoster = vm.roleAccess.CanCreate;
        getUserIdentityId()
            .then(function (userID) {
                if (!vm.employee.Id) {
                    vm.employee.Id = userID;
                }
                return $q.all([
                    loadStateProvinces,
                    (function () {
                        // Date of birth and gender are required if the employee is in
                        // a department other than Dept 900 - 1099.
                        vm.requireDateOfBirth = !vm.userProfile.CompensationProfile
                            || vm.userProfile.CompensationProfile.Name !== DEPT_900
                            || (vm.userProfile.CompensationProfile.Name === DEPT_900
                                && vm.userProfile.HomeAddress.CountryID === 2);
                        vm.requireGender = !vm.userProfile.CompensationProfile
                            || vm.userProfile.CompensationProfile.Name !== DEPT_900;
                    }),
                    getProfileImageUrl().then(function (userImage) {
                        vm.profileImage = userImage;
                    }),
                    getGenders().then(function (gender) {
                        vm.GenderOptions = gender;
                    })
                ]).then(function () {
                    vm.userProfile.Gender = vm.GenderOptions.filter(function (gender) {
                        return gender.Value === vm.userProfile.GenderId;
                    })[0];
                });
            })
            .catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(utilityService.hideLoading);
    }

    function $onChanges() {
        if (vm.userProfile) {
            // Date of birth and gender are required if the employee is in
            // a department other than Dept 900 - 1099.
            vm.requireDateOfBirth = !vm.userProfile.CompensationProfile
                || (vm.userProfile.CompensationProfile.Name !== DEPT_900)
                || (vm.userProfile.CompensationProfile.Name === DEPT_900
                    && vm.userProfile.HomeAddress.CountryID === 2);
            vm.requireGender = !vm.userProfile.CompensationProfile
                || vm.userProfile.CompensationProfile.Name !== DEPT_900;
        }
    }

    function onChangeGender() {
        vm.userProfile.GenderId = vm.userProfile.Gender ?
            vm.userProfile.Gender.Value : null
    }

    function onSubmit() {
        if (vm.editForm && vm.editForm.$invalid) {
            alert("Form is invalid. Please address any validation errors that are displayed.");
            return;
        }

        if (vm.profileImage) {
            if (vm.profileImage.dataUrl) {
                const splitedUrl = vm.profileImage.dataUrl.split(",");
                vm.userProfile.ProfileImage = vm.profileImage;
                vm.userProfile.ProfileImage.OriginalFileName = vm.profileImage.originalFileName;
                vm.userProfile.ProfileImage.ImageData = splitedUrl[1];
                vm.userProfile.ProfileImage.MimeType = splitedUrl[0].substring(splitedUrl[0].indexOf(":") + 1, splitedUrl[0].indexOf(";"));
            }
        }

        utilityService.showLoading();
        vm.save({
            $event: {
                userProfile: vm.userProfile,
                employeeAccount: {
                    ...vm.employee,
                    IcdOffices: [],
                    onModelStateError: modelState => {
                        vm.modelState = modelState;
                    }
                },
                hasSeparatedEditPages: vm.features.separateEditPages
            }
        }).then(() => {
            if (vm.editForm) {
                vm.editForm.$setPristine(true);
            }

            if ((vm.identity.IsSiteAdmin || vm.roleAccess.CanUpdate)
                && Number(vm.loggedInUserID) !== Number(vm.employee.Id)) {
                // Go to the tax info page unless the user is editing their own profile.
                return $state.go("employee.edit.bankInfo");
            }
        }).catch(ex => {
            console.error(ex);
            vm.modelState = ex.data ? ex.data.ModelState : null;
        }).then(function () {
            utilityService.hideLoading();
        });
    }

    function onBeforeUnload() {
        if (vm.editForm && vm.editForm.$dirty) {
            return "You have unsaved changes that will be lost after leaving this page.";
        }
    }

    function onChangeUserAccount() {
        // Handle syncing changes to the user account with the user profile
        mapSharedUserProfileFields(vm.employee, vm.userProfile);
    }

    function onChangeUserProfile() {
        mapSharedUserProfileFields(vm.userProfile, vm.employee);
    }

    function mapSharedUserProfileFields(source, target) {
        target.EmailAddress = source.EmailAddress;
        target.FirstName = source.FirstName;
        target.MiddleName = source.MiddleName;
        target.LastName = source.LastName;
    }

    function getProfileImageUrl() {
        return employeeService.retrieveProfileImageUrl(vm.employee.Id);
    }

    function getUserIdentityId() {
        return employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity.EmployeeID;
            });
    }

    function handleProfileImageFileSelected() {

        if (!vm.profileImageFiles) {
            vm.clearProfileImageUpload();
            return;
        }
        const file = vm.profileImageFiles;

        if (!fileService.isValidImage(file)) {
            alert('Please upload a valid image file')
            return;
        }

        if (fileService.getFileSizeInMB(file) > PROFILE_IMG_SIZE_LIMIT_MB) {
            alert('Please upload a picture smaller than ' + PROFILE_IMG_SIZE_LIMIT_MB + ' MB')
            return;
        }

        fileService.fileToDataUrl(file)
            .then(function (dataUrl) {
                return $uibModal.open({
                    ...ImageCropperModal,
                    resolve: {
                        dataUrl: () => dataUrl,
                        cropHeight: () => 256,
                        cropWidth: () => 256,
                        resultHeight: () => 256,
                        resultWidth: () => 256,
                        areaType: () => "square"
                    }
                }).result
                    .then(function (data) {
                        if (!data) {
                            return $q.when(null);
                        }
                        vm.profileImage.dataUrl = data;
                        return fileService.dataUrlToFile(data, file.name, file.type)
                    }).then(function (croppedFile) {
                        if (croppedFile) {
                            vm.profileImage.file = croppedFile;
                            vm.profileImage.originalFileName = croppedFile.name;
                        }
                    });
            });
    }

    function clearProfileImageUpload() {
        delete vm.profileImage.file;
        delete vm.profileImage.originalFileName;
        delete vm.profileImage.dataUrl;
    }

    function getGenders() {
        return employeeService.retrieveGenders()
            .then(function (genders) {
                return genders.data;
            });
    }
}
